/* eslint-disable @typescript-eslint/no-explicit-any */
import { DragEvent, useRef } from "react";
import appColors from "../../../app/appColors";
import KorocanThumbnailForHesap from "../../../components/business/KorocanThumbnailForHesap";
import { BusinessHelper } from "../../../helpers/BusinessHelper";
import GenelDurumHelper from "../../../helpers/GenelDurumHelper";
import { CsmText } from "../../../library/components/mui/CsmText";
import { DizilimHesapModel } from "../../../models/businessModels/DizilimHesapModel";
import { HesapBilgiVeKullaniciModel } from "../../../models/businessModels/HesapBilgiVeKullaniciModel";
import { SesGrupModel } from "../../../models/businessModels/SesGrupModel";
import { alpha } from "@mui/material";
import JsonHelper from "../../../library/helpers/JsonHelper";

const dizilimMainUnitInPixels = BusinessHelper.KonserDizilim.DizilimMainUnitInPixels;

export type DizilimKoristDragData = {
    x: number,
    y: number,
    id: string
}
interface IDizilimKoristDisplayerProps {
    hesapDizilim: DizilimHesapModel,
    hesaplar: { hesap: HesapBilgiVeKullaniciModel, sesGrup: SesGrupModel }[],
    readonly: boolean,
    genelDurumHelper: GenelDurumHelper,
}

function DizilimKoristDisplayer(props: IDizilimKoristDisplayerProps) {
    const { hesapDizilim, hesaplar, readonly, genelDurumHelper } = props;
    const hesapVeSesGrubu = hesaplar.singleOrDefault(e => e.hesap.id === hesapDizilim.hesapId) ?? { hesap: genelDurumHelper.SeciliKoroModel.hesapBilgiList.single(e => e.id === hesapDizilim.hesapId), sesGrup: null };

    const parentRef = useRef<HTMLDivElement>(null);

    function handleDragStart(e: DragEvent<HTMLDivElement>): void {
        const parentRect = parentRef.current!.getBoundingClientRect();
        const data: DizilimKoristDragData = {
            x: e.clientX - parentRect.left,
            y: e.clientY - parentRect.top,
            id: hesapDizilim.hesapId,
        }

        e.dataTransfer.setData("text/plain", JsonHelper.stringify(data));
        e.dataTransfer.effectAllowed = "move";
    }

    const colors = [
        alpha(appColors.PRIMARY, 0.2),
        alpha(appColors.PRIMARY, 0.8),
        alpha(appColors.SECONDARY, 0.2),
        alpha(appColors.SECONDARY, 0.8),
        alpha(appColors.GREEN, 0.2),
        alpha(appColors.GREEN, 0.8),
        alpha(appColors.YELLOW, 0.2),
        alpha(appColors.YELLOW, 0.8),
    ];

    const tumSesGruplari = hesaplar.select(e => e.sesGrup).distinct();

    function getColorIndex(sesGrupId: string) {
        const found = tumSesGruplari.single(e => e.id === sesGrupId);
        return tumSesGruplari.indexOf(found);
    }

    function findColor(hesapVeSesGrubu: { hesap: HesapBilgiVeKullaniciModel; sesGrup: SesGrupModel | null; }): string {
        if (hesapVeSesGrubu.sesGrup === null)
            return appColors.LIGHTGRAY;

        const foundIndex = getColorIndex(hesapVeSesGrubu.sesGrup.id);
        return colors[foundIndex % 8];
    }

    return <div draggable={!readonly} ref={parentRef}
        onDragStart={readonly ? undefined : handleDragStart}
        style={{
            height: BusinessHelper.KonserDizilim.AvatarWidth,
            width: BusinessHelper.KonserDizilim.AvatarWidth,
            padding: 5,
            zIndex: 11,
            position: "absolute",
            background: findColor(hesapVeSesGrubu),
            borderRadius: 15,
            left: hesapDizilim.locationX * dizilimMainUnitInPixels,
            top: hesapDizilim.locationY * dizilimMainUnitInPixels
        }}>
        <KorocanThumbnailForHesap hesap={hesapVeSesGrubu.hesap} size="normal" genelDurumHelper={genelDurumHelper} />
        <CsmText style={{ flex: 1, textAlign: "center", fontSize: "10px" }} note>{hesapVeSesGrubu.hesap.kullaniciModel.ad} {hesapVeSesGrubu.hesap.kullaniciModel.soyad}</CsmText>
    </div>
}

export default DizilimKoristDisplayer;